import { EditSelectorHost } from "./";

export const NewSelector: React.FC = () => {
  return <EditSelectorHost modeLabel="New" />;
};
